<template>
  <div class="row">
    <div class="col-xl-12 order-xl-10 col-lg-9 order-lg-10 col-md-12 order-md-2 col-sm-12 col-xs-12">
      <div class="row">
        <div class="col-xl-12 order-xl-10 col-lg-12 order-lg-10 col-md-12 col-sm-12 col-xs-12">
          <div class="ui-block responsive-flex">
            <div class="ui-block-title">
              <div class="h6 title">
                All Exercises within category
              </div>
              <exercise-form />
              <div class="align-right">
                <form class="w-search">
                  <div class="form-group with-button">
                    <input
                      v-model="term"
                      class="form-control"
                      type="text"
                      placeholder="Search exercises..."
                    >
                    <button @click.stop.prevent="search1">
                      <app-icon-multiple
                        name="olymp-magnifying-glass-icon"
                        color="gray"
                        size="medium"
                      />
                    </button>
                  </div>
                </form>
                <a
                  href="#"
                  class="btn btn-primary btn-md"
                  @click="$modal.show('exercise-form', {item: {cat_id: catid, title: '', description: ''}})"
                >New Exercise</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <exercise-tags
          :tags="itemTags"
          :catid="catid"
        />
        <div class="col-xl-9 order-xl-10 col-lg-9 order-lg-10 col-md-12 order-md-2 col-sm-12 col-xs-12">
          <div class="ui-block">
            <!-- Forums Table -->

            <table
              v-if="items && items.length"
              class="forums-table"
            >
              <thead>
                <tr>
                  <th class="forum">
                    Title
                  </th>

                  <th class="freshness">
                    Date
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr
                  v-for="item in items"
                  :key="item.id"
                >
                  <td class="forum">
                    <div class="forum-item">
                      <!--<img src="img/forum7.png" alt="forum">-->
                      <div class="content">
                        <router-link
                          :to="{ path: '/exercises/' + item.id }"
                          class="h6 title"
                        >
                          {{ item.name }}
                        </router-link>
                        <p class="text">
                          {{ item.status }}
                        </p>
                        <p class="text">
                          {{ item.tags }}
                        </p>
                      </div>
                    </div>
                  </td>
                  <td class="freshness">
                    <div class="author-freshness">
                      <time
                        class="entry-date updated"
                        datetime="2017-06-24T18:18"
                      >{{ item.created_at | formatDate('MM/dd/yyyy') }}</time>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- ... end Forums Table -->
          </div>

          <!-- Pagination -->
          <pagination
            v-model="currentPage"
            :records="totalItems"
            :per-page="perpage"
            @paginate="paginationChange"
          />
          <!-- ... end Pagination -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Pagination from 'vue-pagination-2'
import exerciseTags from './ExerciseTags'
import ExerciseForm from './ExerciseForm'
import { EventBus } from '../../../event-bus'
import AppIconMultiple from "../../common-apps/common/AppIconMultiple";

export default {
  name: 'ExerciseList',
  components: {AppIconMultiple, Pagination, exerciseTags, ExerciseForm },
  props: {
    catid: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      perpage: 10,
      term: '',
      currentPage: 1
    }
  },
  computed: mapState({
    items: state => state.exercise.items,
    totalItems: state => state.exercise.totalItems,
    itemTags: state => state.exercise.itemTags
  }),
  watch: {
    catid: 'updateExercises'
  },
  created () {
    this.$store.dispatch('exercise/getExerciseTags', this.catid)
    // eslint-disable-next-line
      this.$store.dispatch('exercise/getExercises', { currentPage: 1, perpage: this.perpage, catid: this.catid, status: this.status });
    EventBus.$on('refresh-exercises', (items) => {
      this.$store.commit('exercise/setExercisesSimple', items)
    })
  },
  methods: {
    paginationChange (currentPage) {
      // eslint-disable-next-line
      this.$store.dispatch('exercise/getExercises', { currentPage, perpage: this.perpage, catid: this.catid });
    },
    search1 () {
      // eslint-disable-next-line
      this.$store.dispatch('exercise/search', { currentPage: 1, perpage: this.perpage, catid: this.catid, term: this.term });
    },
    updateExercises () {
      this.$store.dispatch('exercise/getExerciseTags', this.catid)
      // eslint-disable-next-line
      this.$store.dispatch('exercise/getExercises', { currentPage: 1, perpage: this.perpage, catid: this.catid });
    }
  }
}
</script>
